export const PanelCloseIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="fill-current"
      aria-label="Panel Close"
      role="img"
      {...props}
    >
      <path
        d="M15.1996 14.846V9.15712L12.3552 12.0016L15.1996 14.846ZM7.02183 18.4016C6.63072 18.4016 6.29591 18.2623 6.01739 17.9838C5.73887 17.7053 5.59961 17.3705 5.59961 16.9793V7.02378C5.59961 6.63267 5.73887 6.29786 6.01739 6.01934C6.29591 5.74082 6.63072 5.60156 7.02183 5.60156H16.9774C17.3685 5.60156 17.7033 5.74082 17.9818 6.01934C18.2604 6.29786 18.3996 6.63267 18.3996 7.02378V16.9793C18.3996 17.3705 18.2604 17.7053 17.9818 17.9838C17.7033 18.2623 17.3685 18.4016 16.9774 18.4016H7.02183ZM9.15516 16.9793V7.02378H7.02183V16.9793H9.15516ZM10.5774 16.9793H16.9774V7.02378H10.5774V16.9793Z"
        fill="currentColor"
      />
    </svg>
  );
};
